// axios
import axios from 'axios'
import Mgr from '@/services/SecurityService'
const user = new Mgr()

const baseURL = ''
const UNAUTHORIZED = 401
const NOTFOUND = 404
const MethodNotAllowed = 405


const service = axios.create({
  baseURL
  // You can add your headers here
})

service.interceptors.request.use(config => new async function () {
  const token = await user.getAccessToken()
  config.headers.Authorization =  `Bearer ${token}`
  
  return config
})

service.interceptors.response.use(
  response => response,
  error => {
    const {status} = error.response
    if (status === UNAUTHORIZED) {
      user.getSignedIn()
    }
    if (status === NOTFOUND) {
      console.error('404 NOTFOUND')
      console.log(error)
    }
    if (status === MethodNotAllowed) {
      console.error('405 MethodNotAllowed')
      console.log(error)
    }
    return Promise.reject(error)
  }
)

export default service